import { Injectable } from '@angular/core';

import { SingleProductTemplateModel } from '../models/single-product-template-model';
import { TypeOfTemplate } from '../models/templates-types.models';

import { Resolutions } from '@layout/domain/models/layout.models';
import { ImageType, Position } from '@shared/product/models';

@Injectable()
export class SingleProductTemplateConfigurations {
    private static readonly COMMON_SEPARATOR_CONFIG: SingleProductTemplateModel = {
        type: TypeOfTemplate.SingleProductTemplate,
        ulClasses: '',
        liClasses: '',
        name: '',
        cmsStyles: undefined,
        templateConfiguration: {
            imageType: ImageType.double,
            showDescription: false,
            showTags: false,
            showPrice: false,
            showQuickly: false,
            showDetails: false,
            textPosition: Position.none,
            showColors: false,
            showDiscount: false,
            showMadeInExclusive: true,
            media: {
                widthVW: '(max-width: 767px) 100vw, 70vw',
                ratio: '3-2',
                showWaterMark: false,
            },
        },
        imageWidth: {
            useMobileConfig: Resolutions.MOBILE,
            mobile: null,
            desktop: null,
        },
        showName: {
            useMobileConfig: Resolutions.MOBILE,
            mobile: 0,
            desktop: 0,
        },
        skLoad: {
            useMobileConfig: Resolutions.MOBILE,
            mobile: 5,
            desktop: 5,
        },
    };

    public getConfig(): Record<string, SingleProductTemplateModel> {
        return {
            SEPARATOR_25: { ...SingleProductTemplateConfigurations.COMMON_SEPARATOR_CONFIG, name: 'separator25' },
            SEPARATOR_50: { ...SingleProductTemplateConfigurations.COMMON_SEPARATOR_CONFIG, name: 'separator50' },
            FIV: {
                type: TypeOfTemplate.SingleProductTemplate,
                ulClasses: '',
                liClasses: 'w-100',
                name: 'FIV',
                cmsStyles: undefined,
                templateConfiguration: {
                    discardDoubleVideo: false,
                    showSecondImageIfPossible: true,
                    imageType: ImageType.double,
                    showDescription: false,
                    showTags: false,
                    showPrice: false,
                    showQuickly: false,
                    showDetails: false,
                    textPosition: Position.none,
                    showColors: false,
                    showDiscount: false,
                    showMadeInExclusive: false,
                    media: {
                        widthVW: '(max-width: 767px) 100vw, 70vw',
                        ratio: '3-2',
                    },
                },
                imageWidth: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: null,
                    desktop: null,
                },
                showName: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: 0,
                    desktop: 0,
                },
            },
            SEPARATOR_12_5: { ...SingleProductTemplateConfigurations.COMMON_SEPARATOR_CONFIG, name: 'separator12-5' },
            SEPARATOR_SM: { ...SingleProductTemplateConfigurations.COMMON_SEPARATOR_CONFIG, name: 'separatorSM' },
            SEPARATOR_MD: { ...SingleProductTemplateConfigurations.COMMON_SEPARATOR_CONFIG, name: 'separatorMD' },
            SEPARATOR_LG: { ...SingleProductTemplateConfigurations.COMMON_SEPARATOR_CONFIG, name: 'separatorLG' },
            SEPARATOR_XL: { ...SingleProductTemplateConfigurations.COMMON_SEPARATOR_CONFIG, name: 'separatorXL' },
        };
    }
}
